import {setReservationFormListener} from "../listners/setReservationFormListener";
import {formatPhone} from "./formatPhone";

export function initReservationModal() {
  if (DataHelper.store.user) {
    const formattedPhone = formatPhone(DataHelper.store.user.phone);
    $('#tel-reservation').val(formattedPhone);
  }
  setReservationFormListener();
}